import './loading.component.scss';
import { PropsWithChildren } from 'react';
import { NoDataAvailableComponent } from './no-data-available.component';
import { PreloaderComponent } from './preloader.component';
interface LoadingComponentProps extends PropsWithChildren {
  isLoading: boolean;
  noDataAvailable?: boolean;
  message?: string;
  noDataAvailableMessage?: string;
}
export const LoadingComponent = ({
  isLoading,
  children,
  noDataAvailable = false,
  message = 'Loading...',
  noDataAvailableMessage,
}: LoadingComponentProps) => {
  return (
    <div className={isLoading ? 'loading-container show' : 'loading-container'}>
      {children}
      {isLoading && (
        <div className="loading-overlay">
          {/* <Spinner animation="grow" size="sm" role="status" variant="dark">
                    <span className="visually-hidden">Loading...</span>
                </Spinner> */}
          <PreloaderComponent message={message} />
        </div>
      )}
      {!isLoading && noDataAvailable && (
        <div className="loading-overlay">
          <NoDataAvailableComponent message={noDataAvailableMessage} />
        </div>
      )}
    </div>
  );
};
